import { AccountPaymentMethod, PaymentMethod } from '../model/types';

export const isAccountMethod = (
  type: PaymentMethod,
): type is AccountPaymentMethod => {
  return typeof type === 'object' && 'account' in type;
};
